mutation DisconnectPaynet {
  disconnectPaynet {
    id
    paymentSettings {
      publishableKey
      secretKeyMask
      connectedAt
      paynet {
        merchantCode
        secretKeyMask
        saleArea
        connectedAt
      }
    }
  }
}
